// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_dUm","cls2":"PodcastLibraryCarouselAd-cls2_ZZs PodcastLibraryCarouselAd-cls1_dUm"};